<template>
  <div class="schedule">
    <div>
      <b-modal
        size="md"
        no-close-on-backdrop
        hide-footer
        id="modalFinishSchedule"
        title="FINALIZAR"
      >
        <ScheduleFinish
          :schedule="schedule"
          v-on:finish="handleFinishSchedule()"
        />
      </b-modal>

      <b-modal
        no-close-on-backdrop
        centered
        hide-header-close
        hide-footer
        id="imprimir"
        title="FILTRAR"
      >
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="status" class="form-control">
            <option value="PENDENTE">APRAZAMENTOS PENDENTES</option>
            <option value="FINALIZADO">APRAZAMENTOS FINALIZADOS</option>
            <option value="INATIVO">APRAZAMENTOS APAGADOS</option>
            <option value="ALL">TODOS</option>
          </select>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Data de início</h6>
          <input type="date" v-model="start_date" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Data de término</h6>
          <input v-model="end_date" type="date" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <ErrorsMessages :errors="errors" />
          <b-button class="btn-cancel m-1" @click="$bvModal.hide('imprimir')"
            >CANCELAR</b-button
          >
          <v-btn class="btn-filter-sidebar float-right" @click="handleFilter">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </b-modal>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-7">
          <h5 class="title-pages pl-0">APRAZAMENTOS</h5>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-5 text-right">
          <v-btn @click="$bvModal.show('imprimir')" class="btn-filter">
            <i
              :class="[
                'fas fa-filter text-twenty',
                width < 600 ? 'mr-0' : 'mr-2',
              ]"
            ></i
            ><span v-if="width > 600">FILTRAR</span></v-btn
          >
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99">
        <div class="p-5 v-clean" v-if="schedules.length == 0">
          <h6 class="text-center worksansr upper-text">Sem resultados!</h6>
        </div>
        <v-expansion-panels
          v-model="panel_group_prescription_medicine"
          hover
          multiple
          tile
          class="border border-for"
        >
          <v-expansion-panel
            v-for="(schedule, key_group) in schedules"
            :key="key_group"
          >
            <v-expansion-panel-header>
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <h6 class="mb-0 check-text-center">
                    RESIDENTE:
                    {{ schedule.resident_name }}
                  </h6>
                  <h6 class="mb-0 worksansr check-text-center">
                    VALIDADE: {{ formatDate(schedule.start_date, false) }} até
                    {{ formatDate(schedule.end_date, false) }}
                  </h6>
                </div>
                <!-- PRESCRIÇÃO -->
                <div
                  class="
                    col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12
                    d-flex
                    align-items-center
                  "
                >
                  <img
                    v-if="
                      !schedule.finish_user || schedule.status == 'PENDENTE'
                    "
                    class="mr-2 no-user-photo-url"
                    :src="require('../../../../assets/user.png')"
                  />
                  <img
                    v-if="schedule.finish_user && schedule.status != 'INATIVO'"
                    :class="[
                      'mr-2',
                      schedule.finish_user.photo_url
                        ? 'user-photo-url'
                        : 'no-user-photo-url',
                    ]"
                    :src="
                      schedule.finish_user.photo_url
                        ? schedule.finish_user.photo_url
                        : require('../../../../assets/user.png')
                    "
                  />
                  <div>
                    <h6 class="legends mb-0">
                      PRESCRIÇÃO
                      <span
                        :class="[
                          handleClassStatusGroupPrescriptionMedicine(
                            schedule.status
                          ),
                        ]"
                      >
                        {{
                          {
                            PENDENTE: "PENDENTE",
                            CANCELADO: "CANCELADA",
                            FINALIZADO: "FINALIZADA",
                            INATIVO: "APAGADA",
                          }[schedule.status] || ""
                        }}
                      </span>
                      <span
                        v-if="
                          schedule.finish_user && schedule.status != 'INATIVO'
                        "
                      >
                        POR
                      </span>
                    </h6>
                    <h6
                      v-if="
                        schedule.finish_user && schedule.status != 'INATIVO'
                      "
                      class="legends worksansr mb-0"
                    >
                      {{
                        professionalClassCouncilValue({
                          id: schedule.finish_user
                            .professional_class_council_id,
                          name: schedule.finish_user.name,
                          value:
                            schedule.finish_user
                              .professional_class_council_value,
                          cpf: schedule.finish_user.cpf,
                          office: schedule.finish_user.office,
                        })
                      }}
                    </h6>
                  </div>
                </div>
                <!-- APRAZAMENTO -->
                <div
                  class="
                    col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12
                    d-flex
                    align-items-center
                  "
                >
                  <img
                    v-if="
                      !schedule.user_finish_prescription_medicine_time ||
                      schedule.status_prescription_medicine_time == 'PENDENTE'
                    "
                    class="mr-2 no-user-photo-url"
                    :src="require('../../../../assets/user.png')"
                  />
                  <img
                    v-if="
                      schedule.user_finish_prescription_medicine_time &&
                      schedule.status_prescription_medicine_time != 'INATIVO'
                    "
                    :class="[
                      'mr-2',
                      schedule.user_finish_prescription_medicine_time.photo_url
                        ? 'user-photo-url'
                        : 'no-user-photo-url',
                    ]"
                    :src="
                      schedule.user_finish_prescription_medicine_time.photo_url
                        ? schedule.user_finish_prescription_medicine_time
                            .photo_url
                        : require('../../../../assets/user.png')
                    "
                  />
                  <div>
                    <h6 class="legends mb-0">
                      APRAZAMENTO
                      <span
                        :class="[
                          handleClassStatusGroupPrescriptionMedicine(
                            schedule.status_prescription_medicine_time
                          ),
                        ]"
                      >
                        {{
                          {
                            PENDENTE: "PENDENTE",
                            CANCELADO: "CANCELADO",
                            FINALIZADO: "FINALIZADO",
                            INATIVO: "APAGADO",
                          }[schedule.status_prescription_medicine_time] || ""
                        }}
                      </span>
                      <span
                        v-if="
                          schedule.user_finish_prescription_medicine_time &&
                          schedule.status_prescription_medicine_time !=
                            'INATIVO'
                        "
                      >
                        POR
                      </span>
                    </h6>
                    <h6
                      v-if="
                        schedule.user_finish_prescription_medicine_time &&
                        schedule.status_prescription_medicine_time != 'INATIVO'
                      "
                      class="legends worksansr mb-0"
                    >
                      {{
                        professionalClassCouncilValue({
                          id: schedule.user_finish_prescription_medicine_time
                            .professional_class_council_id,
                          name: schedule.user_finish_prescription_medicine_time
                            .name,
                          value:
                            schedule.user_finish_prescription_medicine_time
                              .professional_class_council_value,
                          cpf: schedule.user_finish_prescription_medicine_time
                            .cpf,
                          office:
                            schedule.user_finish_prescription_medicine_time
                              .office,
                        })
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                v-if="schedule.status == 'FINALIZADO'"
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              >
                <h6 class="status-center color-green check-text-center">
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  Prescrição finalizada
                  {{
                    schedule.certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}
                </h6>
                <p v-if="schedule.certificate">
                  <span class="p-2 v-danger">{{ schedule.certificate }}</span>
                </p>
                <h6
                  class="status-center color-green check-text-center"
                  v-if="
                    schedule.status_prescription_medicine_time == 'FINALIZADO'
                  "
                >
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  Aprazamento finalizado
                  {{
                    schedule.prescription_medicine_time_certificate
                      ? "com assinatura eletrônica"
                      : "com assinatura eletrônica"
                  }}
                </h6>
                <p v-if="schedule.prescription_medicine_time_certificate">
                  <span class="p-2 v-danger">{{
                    schedule.prescription_medicine_time_certificate
                  }}</span>
                </p>
              </div>
              <div
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  text-right
                  pl-0
                  pr-0
                "
              >
                <v-btn
                  v-if="schedule.status == 'FINALIZADO'"
                  @click="handlePrint(schedule)"
                  class="btn-print m-1"
                >
                  <i
                    :class="[
                      'fas fa-print text-twenty',
                      width < 600 ? 'mr-0 ' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">IMPRIMIR</span>
                </v-btn>
              </div>
              <div
                v-for="(
                  prescription_medicine, key_medicine
                ) in schedule.prescription_medicines"
                :key="key_medicine"
                class="medicine"
              >
                <div class="row">
                  <div
                    class="
                      col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                      v-clean
                      mb-2
                    "
                  >
                    <h6
                      class="color-deleted text-thirteen check-text-center"
                      v-if="
                        prescription_medicine.prescription_medicine_status ==
                        'EXCLUIDO'
                      "
                    >
                      ESTE MEDICAMENTO FOI EXCLUIDO DA PRESCRIÇÃO!
                    </h6>
                    <h6
                      class="color-blue text-thirteen check-text-center"
                      v-if="prescription_medicine.edited == 1"
                    >
                      ESTE MEDICAMENTO FOI EDITADO -
                      {{ formatDate(prescription_medicine.edited_date, false) }}
                    </h6>
                    <div class="row">
                      <div
                        class="
                          col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12
                          d-flex
                          justify-content-center
                          align-items-center
                        "
                      >
                        <i class="fas fa-capsules fa-2x color-blue"></i>
                      </div>
                      <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12">
                        <h6 class="mb-0 color-black check-text-center">
                          {{ prescription_medicine.medicine_name }}
                        </h6>
                        <h6 class="worksansr break-word check-text-center">
                          {{ prescription_medicine.medicine_active_ingredient }}
                        </h6>
                        <div class="d-flex residenttop-content">
                          <h6
                            class="btn-pendent"
                            v-if="
                              prescription_medicine.type_of_recipe_name ==
                              'CONTROLE ESPECIAL - 2 VIAS'
                            "
                          >
                            CONTROLE ESPECIAL
                          </h6>
                          <h6
                            class="btn-finish"
                            v-if="
                              prescription_medicine.type_of_recipe_name !=
                              'CONTROLE ESPECIAL - 2 VIAS'
                            "
                          >
                            {{ prescription_medicine.type_of_recipe_name }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="
                          col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12
                          d-flex
                          check-justifique-right
                          align-items-center
                          pr-5
                        "
                      >
                        <div>
                          <h6 class="mb-0 check-text-right">
                            {{
                              prescription_medicine.medicine_amount_of_times_name
                            }}
                          </h6>
                          <h6 class="mb-0 worksansr check-text-right">
                            {{ handleDuration(prescription_medicine.duration) }}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_medicine.medicine_list"
                        >
                          LISTA:
                          {{ prescription_medicine.medicine_list }}
                        </p>
                        <p class="mb-0 worksansr legends">
                          Via de administração:
                          {{
                            prescription_medicine.route_of_administration_name
                          }}
                        </p>
                        <p class="mb-0 worksansr legends">
                          Frequência:
                          {{ handleFrequency(prescription_medicine.frequency) }}
                          <br />
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_medicine.frequency != 'EVENTUAL'"
                        >
                          Repetição:
                          {{
                            handleEvery(
                              prescription_medicine.every,
                              prescription_medicine.frequency
                            )
                          }}
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_medicine.frequency == 'SEMANAL'"
                        >
                          Dias da semana:
                          {{ prescription_medicine.dom && "DOM" }}
                          {{ prescription_medicine.seg && "SEG" }}
                          {{ prescription_medicine.ter && "TER" }}
                          {{ prescription_medicine.qua && "QUA" }}
                          {{ prescription_medicine.qui && "QUI" }}
                          {{ prescription_medicine.sex && "SEX" }}
                          {{ prescription_medicine.sab && "SAB" }}
                          <br />
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_medicine.medicine_amount_of_times_name
                          "
                        >
                          Quantidade diária:
                          {{
                            prescription_medicine.medicine_amount_of_times_name
                          }}
                        </p>
                        <div
                          v-if="
                            prescription_medicine.medicine_amount_of_times_type ==
                            'SHIFTS'
                          "
                          class="
                            col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12
                            v-clean
                            mt-1
                            mb-1
                          "
                        >
                          <div class="row">
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pt-0
                                pb-0
                              "
                            >
                              <h6 class="mb-0">TURNO</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pt-0
                                pb-0
                              "
                            >
                              <h6 class="mb-0">QUANTIDADE</h6>
                            </div>
                          </div>

                          <div
                            class="row"
                            v-if="
                              prescription_medicine.dawn &&
                              prescription_medicine.dawn_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">MADRUGADA</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_dawn_quantity
                                    ? `${prescription_medicine.drops_dawn_quantity} GOTA(S)`
                                    : prescription_medicine.ui_dawn_quantity
                                    ? `${prescription_medicine.ui_dawn_quantity} UI`
                                    : prescription_medicine.dawn_quantity
                                }}
                                {{
                                  prescription_medicine.drops_dawn_quantity
                                    ? ""
                                    : prescription_medicine.ui_dawn_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.morning &&
                              prescription_medicine.morning_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">MANHÃ</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_morning_quantity
                                    ? `${prescription_medicine.drops_morning_quantity} GOTA(S)`
                                    : prescription_medicine.ui_morning_quantity
                                    ? `${prescription_medicine.ui_morning_quantity} UI`
                                    : prescription_medicine.morning_quantity
                                }}
                                {{
                                  prescription_medicine.drops_morning_quantity
                                    ? ""
                                    : prescription_medicine.ui_morning_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.afternoon &&
                              prescription_medicine.afternoon_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">TARDE</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_afternoon_quantity
                                    ? `${prescription_medicine.drops_afternoon_quantity} GOTA(S)`
                                    : prescription_medicine.ui_afternoon_quantity
                                    ? `${prescription_medicine.ui_afternoon_quantity} UI`
                                    : prescription_medicine.afternoon_quantity
                                }}
                                {{
                                  prescription_medicine.drops_afternoon_quantity
                                    ? ""
                                    : prescription_medicine.ui_afternoon_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.night &&
                              prescription_medicine.night_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">NOITE</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_night_quantity
                                    ? `${prescription_medicine.drops_night_quantity} GOTA(S)`
                                    : prescription_medicine.ui_night_quantity
                                    ? `${prescription_medicine.ui_night_quantity} UI`
                                    : prescription_medicine.night_quantity
                                }}
                                {{
                                  prescription_medicine.drops_night_quantity
                                    ? ""
                                    : prescription_medicine.ui_night_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.shift_5 &&
                              prescription_medicine.shift_5_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">5º</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_shift_5_quantity
                                    ? `${prescription_medicine.drops_shift_5_quantity} GOTA(S)`
                                    : prescription_medicine.ui_shift_5_quantity
                                    ? `${prescription_medicine.ui_shift_5_quantity} UI`
                                    : prescription_medicine.shift_5_quantity
                                }}
                                {{
                                  prescription_medicine.drops_shift_5_quantity
                                    ? ""
                                    : prescription_medicine.ui_shift_5_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.shift_6 &&
                              prescription_medicine.shift_6_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">6º</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_shift_6_quantity
                                    ? `${prescription_medicine.drops_shift_6_quantity} GOTA(S)`
                                    : prescription_medicine.ui_shift_6_quantity
                                    ? `${prescription_medicine.ui_shift_6_quantity} UI`
                                    : prescription_medicine.shift_6_quantity
                                }}
                                {{
                                  prescription_medicine.drops_shift_6_quantity
                                    ? ""
                                    : prescription_medicine.ui_shift_6_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.shift_7 &&
                              prescription_medicine.shift_7_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">7º</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_shift_7_quantity
                                    ? `${prescription_medicine.drops_shift_7_quantity} GOTA(S)`
                                    : prescription_medicine.ui_shift_7_quantity
                                    ? `${prescription_medicine.ui_shift_7_quantity} UI`
                                    : prescription_medicine.shift_7_quantity
                                }}
                                {{
                                  prescription_medicine.drops_shift_7_quantity
                                    ? ""
                                    : prescription_medicine.ui_shift_7_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              prescription_medicine.shift_8 &&
                              prescription_medicine.shift_8_quantity
                            "
                          >
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">8º</h6>
                            </div>
                            <div
                              class="
                                col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6
                                pb-0
                              "
                            >
                              <h6 class="mb-0 worksansr legends">
                                {{
                                  prescription_medicine.drops_shift_8_quantity
                                    ? `${prescription_medicine.drops_shift_8_quantity} GOTA(S)`
                                    : prescription_medicine.ui_shift_8_quantity
                                    ? `${prescription_medicine.ui_shift_8_quantity} UI`
                                    : prescription_medicine.shift_8_quantity
                                }}
                                {{
                                  prescription_medicine.drops_shift_8_quantity
                                    ? ""
                                    : prescription_medicine.ui_shift_8_quantity
                                    ? ""
                                    : `${prescription_medicine.unit_of_measurement_abbreviation} (S)`
                                }}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_medicine.frequency != 'EVENTUAL' &&
                            (prescription_medicine.duration == 'ATE_A_DATA' ||
                              prescription_medicine.duration ==
                                'DURANTE_UM_PERIODO')
                          "
                        >
                          Data de início:
                          {{
                            formatDate(prescription_medicine.start_date, false)
                          }}
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_medicine.frequency != 'EVENTUAL'"
                        >
                          Duração:
                          {{ handleDuration(prescription_medicine.duration) }}
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_medicine.frequency != 'EVENTUAL' &&
                            prescription_medicine.duration ==
                              'DURANTE_UM_PERIODO'
                          "
                        >
                          Período de:
                          {{ prescription_medicine.duration_time }} dia(s)
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_medicine.frequency != 'EVENTUAL' &&
                            prescription_medicine.duration == 'ATE_A_DATA'
                          "
                        >
                          Data de término:
                          {{
                            formatDate(prescription_medicine.end_date, false)
                          }}
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="
                            prescription_medicine.medicine_amount_of_times_type ==
                              'DAY' ||
                            prescription_medicine.frequency == 'EVENTUAL'
                          "
                        >
                          Quantidade:
                          {{
                            prescription_medicine.drops_quantity
                              ? `${prescription_medicine.drops_quantity} GOTA(S)`
                              : prescription_medicine.ui_quantity
                              ? `${prescription_medicine.ui_quantity} UI`
                              : prescription_medicine.quantity
                          }}
                          {{
                            prescription_medicine.drops_quantity
                              ? ""
                              : prescription_medicine.ui_quantity
                              ? ""
                              : `${prescription_medicine.unit_of_measurement_name} (S)`
                          }}
                        </p>
                        <p
                          class="mb-0 worksansr legends"
                          v-if="prescription_medicine.instruction"
                        >
                          Instrução:
                          {{ prescription_medicine.instruction }}
                        </p>
                        <h6 class="mt-2 legends">
                          MEDICAMENTO CADASTRADO POR:
                          {{ prescription_medicine.user_name }}
                        </h6>
                      </div>
                      <div
                        class="
                          col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12
                          d-flex
                          align-items-start
                        "
                      >
                        <!-- d-flex align-items-center -->
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                        >
                          <div
                            class="row"
                            v-for="prescription_medicine_time in prescription_medicine.prescription_medicine_time"
                            :key="prescription_medicine_time.id"
                          >
                            <div
                              v-show="
                                prescription_medicine.frequency != 'EVENTUAL'
                              "
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <LabelRequiredField label="HORÁRIO" />
                              <input
                                disabled
                                v-if="schedule.status == 'INATIVO'"
                                :value="prescription_medicine_time.time"
                                type="time"
                                class="form-control"
                              />
                              <input
                                :disabled="
                                  prescription_medicine.prescription_medicine_status ==
                                    'EXCLUIDO' ||
                                  prescription_medicine.edited == 1
                                "
                                v-if="
                                  prescription_medicine_time.time &&
                                  schedule.status != 'INATIVO'
                                "
                                :value="prescription_medicine_time.time"
                                :ref="`schedule_${schedule.id}`"
                                :data-id="prescription_medicine_time.id"
                                :data-prescription_medicine_id="
                                  prescription_medicine_time.prescription_medicine_id
                                "
                                type="time"
                                class="form-control"
                              />
                              <input
                                v-if="
                                  !prescription_medicine_time.time &&
                                  schedule.status != 'INATIVO'
                                "
                                :ref="`schedule_${schedule.id}`"
                                :data-id="prescription_medicine_time.id"
                                :data-prescription_medicine_id="
                                  prescription_medicine_time.prescription_medicine_id
                                "
                                type="time"
                                class="form-control"
                              />
                            </div>
                            <div
                              :class="[
                                prescription_medicine.frequency != 'EVENTUAL'
                                  ? 'col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'
                                  : 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12',
                              ]"
                            >
                              <label>QUANTIDADE</label>
                              <input
                                disabled
                                :value="`${
                                  prescription_medicine_time.drops
                                    ? `${prescription_medicine_time.drops} GOTA(S)`
                                    : prescription_medicine_time.ui
                                    ? `${prescription_medicine_time.ui} UI`
                                    : prescription_medicine_time.quantity
                                } ${
                                  prescription_medicine_time.drops
                                    ? ''
                                    : prescription_medicine_time.ui
                                    ? ''
                                    : `- ${prescription_medicine_time.unit_of_measurement_value} (S)`
                                }`"
                                type="text"
                                class="form-control"
                              />
                            </div>
                          </div>
                          <div
                            v-if="
                              prescription_medicine.frequency != 'EVENTUAL' &&
                              prescription_medicine.prescription_medicine_time.find(
                                (time) => (time.time ? true : false)
                              )
                            "
                            class="text-right"
                          >
                            <v-btn
                              @click="handleEditTime(prescription_medicine)"
                              class="v-primary"
                              ><i class="fas fa-edit mr-2"></i> EDITAR
                              HORÁRIO(S)</v-btn
                            >
                          </div>
                          <div
                            v-if="
                              prescription_medicine.frequency != 'EVENTUAL' &&
                              schedule.status_prescription_medicine_time ==
                                'PENDENTE' &&
                              prescription_medicine.prescription_medicine_time
                                .length > 0 &&
                              !prescription_medicine
                                .prescription_medicine_time[0].time
                            "
                            class="text-right"
                          >
                            <v-btn
                              :disabled="loadingFinishSchedule"
                              @click="handleModalFinishSchedule(schedule)"
                              class="btn-save"
                            >
                              <i class="fas fa-check mr-2 text-twenty"></i>
                              {{
                                loadingFinishSchedule ? "CARREGANDO" : "SALVAR"
                              }}
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <ErrorsMessages :errors="errors" />
                <div :disabled="loadingUpdate" class="col-md-12 text-right">
                  <confirmation-dialog
                    :loading="loadingDeleteSchedule"
                    :disabled="loadingDeleteSchedule"
                    v-if="
                      schedule.status_prescription_medicine_time == 'FINALIZADO'
                    "
                    message-title="CONFIRMAÇÃO"
                    message-body="Deseja realmente apagar o aprazamento?"
                    open-left-icon="fa-trash"
                    open-class="btn-delete"
                    open-text="REMOVER"
                    @yes="handleDelete(schedule.id)"
                  />
                  <v-btn
                    :disabled="loadingFinishSchedule"
                    v-if="
                      schedule.status_prescription_medicine_time == 'FINALIZADO'
                    "
                    @click="update(schedule)"
                    class="btn-save m-1"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>
                    {{ loadingFinishSchedule ? "CARREGANDO" : "SALVAR" }}
                  </v-btn>
                  <v-btn
                    :disabled="loadingFinishSchedule"
                    v-if="
                      schedule.status_prescription_medicine_time == 'PENDENTE'
                    "
                    @click="handleModalFinishSchedule(schedule)"
                    class="btn-save m-1"
                  >
                    <i class="fas fa-check mr-2 text-twenty"></i>
                    {{ loadingFinishSchedule ? "CARREGANDO" : "FINALIZAR" }}
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <b-pagination
            align="right"
            v-if="schedules.length > 0"
            @input="paginate()"
            v-model="page"
            :total-rows="total"
            :per-page="5"
          />
        </div>
        <b-modal
          no-close-on-backdrop
          id="edit_time"
          title="ALTERAR HORÁRIO(S)"
          hide-footer
          hide-header-close
        >
          <edit-time
            :prescription_medicine="edit_prescription_medicine"
            @paginate="paginate"
          />
        </b-modal>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../templates/Components/ErrorsMessages";

import LabelRequiredField from "../../../../templates/Components/LabelRequiredField";

import ConfirmationDialog from "../../../../templates/Components/ConfirmationDialog";

import ScheduleFinish from "../../../../templates/Prescription/Schedule/Finish";

import EditTime from "./edit-time.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import routes from "../../../../routes";

import { userData } from "../../../../lib/functions";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

export default {
  name: "Schedules",
  components: {
    ErrorsMessages,
    LabelRequiredField,
    ConfirmationDialog,
    ScheduleFinish,
    EditTime,
  },
  data() {
    return {
      page: 1,
      total: 0,
      isActiveFilter: false,
      permissions: {},
      user_id: "",
      rest_home_id: "",
      resident_id: "",
      resident: {},
      status: "PENDENTE",
      start_date: "",
      end_date: "",
      schedules: [],
      schedule: null,
      group_prescription_medicine: {},
      prescription_medicine: {},
      edit_prescription_medicine: {},
      errors: [],
      loading: false,
      loadingUpdate: false,
      loadingDeleteSchedule: false,
      loadingFinishSchedule: false,
      keyGroup: 0,
      keyMedicine: 0,
      width: window.screen.width,
      panel_group_prescription_medicine: [],
      panel_prescription_medicine: [],
    };
  },
  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  methods: {
    formatDate,
    professionalClassCouncilValue,
    handleClassStatusGroupPrescriptionMedicine(status) {
      return (
        {
          PENDENTE: "text-warning",
          CANCELADO: "text-cancel",
          FINALIZADO: "text-sucess",
          INATIVO: "text-inativi",
        }[status] || ""
      );
    },

    handleEditTime(prescription_medicine) {
      this.edit_prescription_medicine = prescription_medicine;
      this.$bvModal.show("edit_time");
    },

    handleOnResize() {
      this.width = window.innerWidth;
    },
    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },
    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
    async retrieve() {
      let { permissions, user } = userData();

      this.user_id = user.id;
      this.rest_home_id = user.rest_home_id;
      this.permissions = permissions;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      await this.paginate();
    },
    async paginate(
      keyGroup = null,
      valueGoup = 0,
      keyMedicine = null,
      valueMedicine = 0
    ) {
      try {
        this.loading = true;
        this.panel_group_prescription_medicine = [];
        this.panel_prescription_medicine = [];
        this.schedules = [];
        this.errors = [];

        const {
          rest_home_id,
          resident_id,
          status,
          start_date,
          end_date,
          page,
        } = this;

        let params = {
          rest_home_id,
          resident_id,
          status,
          start_date,
          end_date,
          page,
          type: "LONGO_PRAZO",
        };

        const response = await api.get("/rest-home/resident/schedules", {
          params,
        });

        const { error, errors, schedules, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.isActiveFilter = false;
          this.schedules = schedules;
          this.total = total;
          if (keyGroup) {
            this.panel_group_prescription_medicine = [valueGoup];
            if (keyMedicine) {
              this.panel_prescription_medicine = [valueMedicine];
            }
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleChangeQuantity() {
      this.paginate();
    },
    handleFinishSchedule() {
      this.$bvModal.hide("modalFinishSchedule");
      this.paginate();
    },
    handleToBack: () => routes.go(-1),
    handleModalFinishSchedule(schedule) {
      let { user_id } = this;
      let { id, prescription_medicines } = schedule;

      let prescription_medicine = [];
      let prescription_medicine_time = [];

      let refs = this.$refs[`schedule_${id}`];

      for (let item of refs) {
        let obj = {
          id: item.dataset.id,
          time: item.value,
          prescription_medicine_id: item.dataset.prescription_medicine_id,
        };

        prescription_medicine_time.push(obj);
      }

      for (let item of prescription_medicines) {
        let obj = {
          id: item.id,
          frequency: item.frequency,
          edited: item.edited,
          end: item.end,
          group_prescription_medicine_start_date:
            item.group_prescription_medicine_start_date,
          group_prescription_medicine_end_date:
            item.group_prescription_medicine_end_date,
        };

        prescription_medicine.push(obj);
      }

      let params = {
        id,
        user_id,
        prescription_medicine,
        prescription_medicine_time,
      };

      schedule.params = params;

      this.schedule = schedule;

      this.$bvModal.show("modalFinishSchedule");
    },
    async update(schedule) {
      try {
        let { user_id } = this;
        let { id, prescription_medicines } = schedule;

        let prescription_medicine = [];
        let prescription_medicine_time = [];

        let refs = this.$refs[`schedule_${id}`];

        for (let item of refs) {
          let obj = {
            id: item.dataset.id,
            time: item.value,
            prescription_medicine_id: item.dataset.prescription_medicine_id,
          };

          prescription_medicine_time.push(obj);
        }

        for (let item of prescription_medicines) {
          let obj = {
            id: item.id,
            frequency: item.frequency,
          };

          prescription_medicine.push(obj);
        }

        let params = {
          id,
          user_id,
          prescription_medicine,
          prescription_medicine_time,
        };

        const response = await api.patch("/rest-home/schedule", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.paginate();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleDelete(id) {
      try {
        this.loadingDeleteSchedule = true;

        let params = { id };

        const response = await api.patch(
          "/rest-home/schedule/clear-time",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.paginate();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingDeleteSchedule = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePrint({ id }) {
      let route = this.$router.resolve({
        name: "schedule_print",
        params: { id },
      });

      window.open(route.href, "_blank");
    },
    handleFilter() {
      this.paginate();
      this.$bvModal.hide("imprimir");
    },
  },
};
</script>

<style>
.schedule .medicine .capsule {
  width: 20px;
}

.schedule .medicine .name {
  margin-left: 10px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
}
.schedule .medicine .frequency {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}
.schedule .medicine .frequency strong {
  font-size: 18px;
}
.schedule .information-medicine {
  width: 34%;
}
.schedule .information-schedule {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
